/** Safe fragment for CSV/PNG filenames (alphanumeric + underscore). */
export function safeParityFilenameSlug(value: string): string {
  return value.replace(/[^a-zA-Z0-9]/g, '_');
}
